export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/thumbnail-0a80ea6ae69195cad38b57960638104e.jpg";